import { GPStatusType } from './status.enums';

export interface GPStatusCreateRequest {
  name: string;
  color: string;
  type: number;
}

export interface GPStatusCreateResponse {
  id: string;
}

export interface GPStatus {
  id: string;
  name: string;
  color: string;
  position: number;
  type: number;
}

export type GPStatusListResponse = GPStatus[];

export interface GPStatusEditRequest {
  id: string;
  name: string;
  color: string;
  type: number;
}

export interface GPStatusPositionEditRequest {
  id: string;
  newPosition: number;
}

export interface GPStatusListRequest {
  statusTypes?: GPStatusType;
}

export const GPStatusColor: Record<string, string> = {
  dark: '#3B3B3B',
  gray: '#ADB5BD',
  red: '#FF6B6B',
  pink: '#F06595',
  grape: '#CC5DE8',
  violet: '#845EF7',
  indigo: '#5C7CFA',
  blue: '#339AF0',
  cyan: '#22B8CF',
  teal: '#20C997',
  green: '#51CF66',
  lime: '#94D82D',
  yellow: '#FCC419',
  orange: '#FF922B',
  primary: '#6C76A7',
};

export const GPStatusColorRequest: Record<string, string> = {
  '#3B3B3B': 'dark',
  '#ADB5BD': 'gray',
  '#FF6B6B': 'red',
  '#F06595': 'pink',
  '#CC5DE8': 'grape',
  '#845EF7': 'violet',
  '#5C7CFA': 'indigo',
  '#339AF0': 'blue',
  '#22B8CF': 'cyan',
  '#20C997': 'teal',
  '#51CF66': 'green',
  '#94D82D': 'lime',
  '#FCC419': 'yellow',
  '#FF922B': 'orange',
  '#6C76A7': 'primary',
};
